// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.delete-btn[data-v-552c5e5b] {\n    display: flex;\n    align-self: center;\n    margin-left: 8px;\n    padding: 1px;\n    cursor: pointer;\n}\n.dash-circle[data-v-552c5e5b] {\n    fill: #D56C9C;\n    width: 18px;\n    height: 18px;\n}\n", ""]);
// Exports
module.exports = exports;
